import { SocialProofNudge } from 'store/product/types';

/**
 * Retrieves the social proof data based on the provided parameters.
 * @param social_proof_nudges - The social proof nudges object.
 * @param socialProofExperimentSuccess - A boolean indicating the success of the social proof experiment.
 * @returns The social proof data if available, otherwise null.
 */
export const getSocialProofData = (
  social_proof_nudges: SocialProofNudge,
  socialProofExperimentSuccess: boolean
) => {
  if (!social_proof_nudges) {
    return null;
  }

  if (socialProofExperimentSuccess) {
    const key =
      social_proof_nudges &&
      social_proof_nudges.nudges &&
      Object.keys(social_proof_nudges.nudges)[0];
    return (
      (social_proof_nudges.nudges && social_proof_nudges.nudges[key]) || null
    );
  }
};

export const socialProofTrackingData = (
  showNudge: boolean,
  eligible_nudge_ids: any,
  socialProofData: any
) => {
  const trackingObject = {
    socialProofsCartL7Available:
      eligible_nudge_ids && eligible_nudge_ids.includes('A2C_7'),
    socialProofsCartL15Available:
      eligible_nudge_ids && eligible_nudge_ids.includes('A2C_15'),
    socialProofsOrderL7Available:
      eligible_nudge_ids && eligible_nudge_ids.includes('O_7'),
    socialProofsOrderL15Available:
      eligible_nudge_ids && eligible_nudge_ids.includes('O_15'),
    socialProofsShown:
      (showNudge && socialProofData && socialProofData.metric_name) || 'NA',
  };
  return trackingObject;
};
